// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAuth } from "firebase/auth";
import { LIISA_API_URL, LIISA_MOCK_API_URL } from "../utils/env";

const BASE_URL = LIISA_MOCK_API_URL || LIISA_API_URL;
if (!BASE_URL) {
  console.warn("Liisa api url not in env");
}

// initialize an empty api service that we'll inject endpoints into later as needed
export const buildAPI = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: async (headers) => {
      // setup utility for adding headers in test
      if (process.env["NODE_ENV"] === "test") {
        headers.set("Authorization", `Bearer TEST`);

        const testHeaders = process.env["BUILD_API_TEST_HEADERS"];

        if (testHeaders) {
          const parsedHeaderMap = JSON.stringify(testHeaders);

          Object.entries(parsedHeaderMap).forEach(([key, value]) => {
            headers.set(key, value);
          });
        }
      } else {
        const user = getAuth()?.currentUser;
        if (user) {
          headers.set("Authorization", `Bearer ${await user.getIdToken()}`);
        } else {
          // DELETE ME ONCE WE HAVE AUTH
          headers.set("Authorization", `Bearer TEST`);
        }
      }

      return headers;
    },
  }),
  endpoints: () => ({}),
});
